export default {
  GET_LIST: '/auth/bevolClaim/findList',
  SAVE_FUNCTION: '/auth/bevolClaim/save',
  GET_FUNCTION_DETAIL: '/auth/bevolClaim/find',
  UPDATE_FUNCTION: '/auth/bevolClaim/update',
  GET_DLITE_FUNCTION: '/auth/compositionFunctionClaim/findFilter',
  GET_BEVOL_CLAIM: '/auth/bevolClaim/findFilter',
  EXPORT: '/auth/bevolClaim/export'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/bevolFunction.js